import { Button, Elevation, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import PaginatedTable from '../../../components/PaginatedTable';
import Text from '../../../components/Text';
import { useTagListQuery } from '../../../generated/graphql';
import TagCreateOverlay from '../components/TagCreateOverlay';
import TagListItem from '../components/TagListItem';
import { dummyTags } from '../dummy';

const TagListPage = () => {
  const navigate = useNavigate();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const { data, loading, error } = useTagListQuery({
    fetchPolicy: 'network-only',
  });

  const onCreated = (modelId: string) => {
    AppToaster.success('Attribut hinzugefügt!');
    navigate(`/tags/${modelId}`);
  };

  const tags = data?.tags || [];

  return (
    <ContentCard elevation={Elevation.TWO} className="mb-5">
      <TagCreateOverlay
        isOpen={isCreateDialogOpen}
        onSuccess={onCreated}
        onClose={() => setIsCreateDialogOpen(false)}
      />
      <ContentCardHeader
        leftElement={
          <Text large className="mr-2">
            Attribute
          </Text>
        }
        rightElement={
          <Button
            text="Hinzufügen"
            icon={IconNames.ADD}
            intent={Intent.PRIMARY}
            className="ml-2"
            onClick={() => setIsCreateDialogOpen(true)}
          />
        }
      />
      <PaginatedTable
        columns={['', 'Name', 'Beschreibung']}
        interactive
        loading={loading}
        hasError={!!error}
        empty={!tags.length}
      >
        {(loading ? dummyTags : tags || []).map((tag) => (
          <TagListItem
            key={tag.id}
            item={tag}
            skeleton={loading}
            onClick={() => !loading && navigate(`/tags/${tag.id}`)}
          />
        ))}
      </PaginatedTable>
    </ContentCard>
  );
};

export default TagListPage;
